<template>
  <div class="header-wrap">
    <div class="header">
      <p class="hospital-name">
        <img class="hospitalLogo" :src="authInfo.hospitalList[0].institutionLogo" alt="">
        <!-- <img class="hospitalLogo" src="@/assets/images/logo.png" alt=""> -->
        {{authInfo.hospital}}
      </p>
      <div class="login-info-wrap">
        <div class="doctor-name">
           <Icon  type="md-person" style="margin-right:4px" />
           <div>{{authInfo.userName}}</div>
        </div>
        <div class="line"></div>
        <div class="doctor-info">
          <div>{{authInfo.deptName}}</div>
          <div>{{authInfo.title}}</div>
        </div>
        <!-- <Dropdown trigger="click" class="myivu-dropdown">
          <a href="javascript:void(0)">
            <Icon type="ios-arrow-down" style="margin-left:5px"></Icon>
          </a>
          <DropdownMenu  slot="list">

          </DropdownMenu>
        </Dropdown> -->
         <Dropdown trigger="click" class="myivu-dropdown" @on-click="handleSwich">
          <a href="javascript:void(0)">
            <span class="labelStatus">{{onlineText}}</span>
            <Icon type="ios-arrow-down" style="margin-left:5px"></Icon>
          </a>
          <DropdownMenu  slot="list">
             <DropdownItem  class="dropdownMenuDiv" name="1">在线</DropdownItem>
             <DropdownItem  class="dropdownMenuDiv" name="0" divided>离线</DropdownItem>
             <DropdownItem  class="dropdownMenuDiv" name="2" divided>
                退出
             </DropdownItem>
          </DropdownMenu>
        <!-- -->

        </Dropdown>

        <Dropdown trigger="click" @on-click="handleSwichSet">
            <a href="javascript:void(0)">
              <Icon type="md-settings" color="#fff" size="20px" class="settings-header"/>
              <!-- <Icon type="ios-settings-outline" /> -->
            </a>
            <DropdownMenu slot="list">
                <DropdownItem name="schedule">自主排班</DropdownItem>

            </DropdownMenu>
        </Dropdown>
      </div>
    </div>

     <selfSchedule
      :parameter="isScheduleModel"
      v-on:handlermodalCancel="handlerScheduleModelCancel"></selfSchedule>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { api } from '@/services'
import selfSchedule from '../fun_right/selfSchedule/index' //  自主排班

export default {
  components: {
    selfSchedule
  },
  data () {
    return {
      // 自主排班
      isScheduleModel: false,
      onlineText: '',
      onlineStatus: ''
    }
  },

  created () {
    this.handleGetOnlineStatus()
  },
  computed: {
    ...mapGetters({
      asideCollapse: 'app/asideCollapse',
      authInfo: 'auth/info'
    })
  },
  methods: {
    handleSwichSet (name) {
      if (name === 'schedule') {
        this.handlerSelfSchedule()
      }
      console.log(name)
    },
    // 自主排班
    handlerSelfSchedule () {
      this.isScheduleModel = true
    },
    handlerScheduleModelCancel () {
      this.isScheduleModel = false
    },
    handleSwich (name) {
      console.log(name)
      let status = ''
      let onlineText = ''
      if (name === '1') {
        onlineText = '在线'
        status = 1
      } else if (name === '0') {
        onlineText = '离线'
        status = 0
      } else {
        return this.handleLogout()
      }

      api.switchOnlineStatus({
        data: {
          params: {
            onlineStatus: status
          }
        }
      }).then(res => {
        if (res.code === 0) {
          this.onlineStatus = status
          this.onlineText = onlineText
          console.log(this.onlineStatus)
        }
      })
    },
    async handleLogout () {
      const success = await this.$store.dispatch('auth/logout')
      if (success) {
        window.location.reload()
      }
    },
    handleGetOnlineStatus () {
      api.getOnlineStatus().then(res => {
        if (res.code === 0) {
          this.onlineText = res.data.onlineText || ''
          this.onlineStatus = res.data.onlineStatus
        }
      })
    }
  }
}
</script>

<style lang="scss">
.hospitalLogo{
  width: 20px;
  height: 20px;
}
.header-wrap {
  width: 960px;
  height: 40px;
  position: relative;
  margin-bottom: 3px;
}
.header {
  width: 960px;
  height: 40px;
  background: #72BEFF;
  box-shadow: 0px 0px 9px 3px rgba(225, 225, 225, 0.46);
  padding: 0 35px 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1px;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
}
.hospital-name {
  font-size: 13px;
  font-weight:bold;
  font-family: 'MicrosoftYaHei';
  text-shadow:0px 2px 3px rgba(0, 0, 0, 0.35);
  img{
    vertical-align: middle;
    margin-right: 4px;
  }
}
.login-info-wrap {
  height: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}
.doctor-info {
  height: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 7px;
  font-weight: 500;
  line-height: 7px;
}
.line {
  width: 1px;
  height: 17px;
  background: #fff;
  margin:0 5px;
}
.doctor-name{
    height: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    padding:4px 0 7px 0;
    font-size:8px;
    font-weight:500;
    line-height: 9px;
}
.myivu-dropdown{
  .ivu-icon{
    color:#fff;
  }
}
.ivu-select-dropdown .dropdownMenuDiv {
  text-align: center;
  font-size: 9px!important;
  color:#72BEFF;
  cursor: pointer;
}
// .ivu-dropdown-item .dropdownMenuDiv {
//   text-align: center;
//   font-size: 9px!important;
//   color:#72BEFF;
//   cursor: pointer;
// }
.labelStatus{
  font-size: 9px;
  color: #fff;
}
.settings-header{
  font-family: 0.33rem;
  margin-left: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/header/index.vue